import { render } from "./lifeNote.vue?vue&type=template&id=ddcf35a0&scoped=true"
import script from "./lifeNote.vue?vue&type=script&lang=js"
export * from "./lifeNote.vue?vue&type=script&lang=js"

import "./lifeNote.vue?vue&type=style&index=0&id=ddcf35a0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddcf35a0"]])

export default __exports__